// project import
import main from './main';
import makeAppointment from './makeAppointment';
import medCard from './medcard';
import myAppointments from './myAppointments';
import promotions from './promotions';
import contacts from './contacts';
import hospitalizations from './hospitalizations';
import medicalCommission from './medicalCommission';
import qrCode from './qrCode';
import admin from './admin';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [main, makeAppointment, medCard, myAppointments, hospitalizations, medicalCommission, qrCode, admin, promotions, contacts]
};

export default menuItems;
